import React , {useState}  from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';
import { AppProvider } from './context/AppContext';
import {  BrowserRouter,  Route,   Routes, } from "react-router-dom";
import Loading from './components/Loading';
import MapPage from './pages/Map';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Home from './pages/Home';
import JoinUs from './pages/JoinUs';
import About from './pages/About';
import Admin from './admin/Admin';
import Workers from './admin/pages/Workers';
import Markers from './admin/pages/Markers';
import Users from './admin/pages/Users';
import Notifications from './admin/pages/Notifications';
import Packages from './pages/Packages';
import SinglePackage from './pages/SinglePackage';
import PackagesMangment from './admin/pages/PackagesMangment';
import SubPackages from './admin/pages/SubPackages';
import Orders from './admin/pages/Orders';
import MarketingMarkers from './admin/pages/MarketingMarkers';
import ProfileAbout from './pages/ProfileAbout';
import CartPage from './pages/CartPage';
import EditProfile from './pages/EditProfile';
import UnderWork from './pages/UnderWork';
import OrderPage from './pages/OrderPage';
import OrdersArchive from './pages/OrdersArchive';
import ConfirmOrder from './pages/ConfirmOrder';
import SearchedPackages from './pages/SearchedPackages';
import PlacesPage from './pages/PlacesPage';
import ExperiencesPage from './pages/ExperiencesPage';
import SingleExperince from './pages/SingleExperince';
import SinglePlace from './pages/SinglePlace';
import Expereinces from './admin/pages/Expereinces';
import Places from './admin/pages/Places';




const App = () => {



  return (

    <AppProvider>

   
   <BrowserRouter>
 
  
          <Routes>
            
              <Route
                path="/map"
                element={
                <MapPage />
                }
              />
            

            
              <Route
                path="/"
                element={
                <Home />
                }
              />
                   
            
              <Route
                path="/login"
                element={
                <Login />
                }
              />

              <Route
                path="/signUp"
                element={
                <Signup />
                }
              />

              <Route
                path="/join"
                element={
                <JoinUs />
                }
              />

              <Route
                path="/packages"
                element={
                <Packages />
                }
              />

              <Route
                path="/package/:packageId"
                element={
                <SinglePackage />
                }
              />

              <Route
                path="/experinces/:experinceId"
                element={
                <SingleExperince />
                }
              />

              <Route
                path="/places/:placeId"
                element={
                <SinglePlace />
                }
              />

              <Route
                path="/about"
                element={
                <About />
                }
              />

              <Route
                path="/confirm-order"
                element={
                <ConfirmOrder />
                }
              />

              <Route
                path="/all-places"
                element={
                <PlacesPage />
                }
              />

              <Route
                path="/all-experinces"
                element={
                <ExperiencesPage />
                }
              />

              <Route
                path="/package-search/:searchFor"
                element={
                <SearchedPackages />
                }
              />

              <Route
                path="/profile/:userId"
                element={
                <ProfileAbout />
                }
              />

              <Route
                path="/order/:orderId"
                element={
                <OrderPage />
                }
              />

              <Route
                path="/orders-archive/:userId"
                element={
                <OrdersArchive />
                }
              />

              <Route
                path="/edit-profile/:userId"
                element={
                <EditProfile />
                }
              />

              <Route
                path="/cart"
                element={
                <CartPage />
                }
              />


    <Route
            
            path="/dashboard"
            element={
              <Admin  />
            }
          />

    <Route
            
            path="/dashboard/login"
            element={
              <Login  />
            }
          />

    <Route
            
            path="/dashboard/workers"
            element={
              <Workers  />
            }
          />

    <Route
            
            path="/dashboard/markers"
            element={
              <Markers  />
            }
          />

    <Route
            
            path="/dashboard/marketings"
            element={
              <MarketingMarkers  />
            }
          />

    <Route
            
            path="/dashboard/notifications"
            element={
              <Notifications  />
            }
          />

    <Route
            
            path="/dashboard/packages"
            element={
              <PackagesMangment  />
            }
          />

    <Route
            
            path="/dashboard/orders"
            element={
              <Orders  />
            }
          />

    <Route
            
            path="/dashboard/subpackages"
            element={
              <SubPackages  />
            }
          />

    <Route
            
            path="/dashboard/experiences"
            element={
              <Expereinces  />
            }
          />

    <Route
            
            path="/dashboard/places"
            element={
              <Places  />
            }
          />

    <Route
            
            path="/dashboard/users"
            element={
              <Users  />
            }
          />
                   
           
          </Routes>
       
               
        </BrowserRouter>



  

  


    </AppProvider>
  )
}

export default App